import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/sprites/common-sprite.svg'


const _hoisted_1 = _imports_0 + '#app-logo-text'
const _hoisted_2 = _imports_0 + '#app-logo-image'
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = ["xlink:href"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["xlink:href"]
const _hoisted_10 = ["xlink:href"]
const _hoisted_11 = {
  key: 2,
  class: "sub-container"
}
const _hoisted_12 = { class: "nav" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", { min: _ctx.sub }])
  }, [
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("svg", { class: "app-logo-text" }, [
          _createElementVNode("use", { "xlink:href": _hoisted_1 })
        ]),
        _createElementVNode("svg", { class: "app-logo-image" }, [
          _createElementVNode("use", { "xlink:href": _hoisted_2 })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, (route, routeIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: routeIndex }, [
            (_ctx.isExternal(route.path))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: route.path,
                  target: "_blank",
                  rel: "noopener",
                  class: _normalizeClass(route.class)
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                    _createElementVNode("use", {
                      "xlink:href": require('@/assets/images/sprites/common-sprite.svg') + route.icon
                    }, null, 8, _hoisted_7)
                  ])),
                  _createElementVNode("span", null, _toDisplayString(route.name), 1)
                ], 10, _hoisted_5))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: _normalizeClass(["a", [route.class, { active: _ctx.isActive(route) }]]),
                  onClick: ($event: any) => (_ctx.handleMenuClick(route))
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["icon", { rotated: route.sub && _ctx.isActive(route) }])
                  }, [
                    _createElementVNode("use", {
                      "xlink:href": require('@/assets/images/sprites/common-sprite.svg') + route.icon
                    }, null, 8, _hoisted_9)
                  ], 2)),
                  _createElementVNode("span", null, _toDisplayString(route.name), 1),
                  (route.hasSubIcon)
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 0,
                        class: _normalizeClass(["icon arrow", { rotated: route.sub && _ctx.isActive(route) }])
                      }, [
                        _createElementVNode("use", {
                          "xlink:href": require('@/assets/images/sprites/common-sprite.svg') + '#right-arrow-icon'
                        }, null, 8, _hoisted_10)
                      ], 2))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_8)),
            (route.sub && _ctx.isActive(route))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["sub", { active: _ctx.isActive(route) }])
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.sub, (sub, subIndex) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: subIndex,
                          class: _normalizeClass(["a", [sub.class, { active: _ctx.isSubActive(sub.path) }]]),
                          onClick: ($event: any) => (_ctx.goToSub(sub.path))
                        }, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_14, [
                            _createElementVNode("use", {
                              "xlink:href": require('@/assets/images/sprites/common-sprite.svg') + sub.icon
                            }, null, 8, _hoisted_15)
                          ])),
                          _createElementVNode("span", null, _toDisplayString(sub.name), 1)
                        ], 10, _hoisted_13))
                      }), 128))
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ], 2))
}